module.exports = __webpack_public_path__ + "static/media/8.30aa9e80.jpg";